module.exports = __webpack_public_path__ + "static/media/skill_games.4a2c410a.svg";